import { ReactNode } from 'react';

import { Stack, Typography } from 'libs/ui';

import { HeaderStyled } from './ContentHeader.styles';

interface Props {
  header: string;
  rightContent?: ReactNode;
  headerAfterContent?: ReactNode;
  className?: string;
  title?: string;
}

export const ContentHeader = ({
  header,
  rightContent,
  headerAfterContent,
  className,
  title,
}: Props) => (
  <Stack
    alignItems="center"
    as="header"
    className={className}
    direction="row"
    flexWrap="wrap"
    justifyContent="space-between"
    spacing={16}
  >
    <HeaderStyled
      alignItems="center"
      className="header-content"
      direction="row"
      flexWrap="wrap"
      spacing={16}
    >
      <Typography
        as="h1"
        className="header-title"
        title={title}
        variant="headline"
      >
        {header}
      </Typography>
      {headerAfterContent}
    </HeaderStyled>
    {rightContent}
  </Stack>
);
